module.exports = __webpack_public_path__ + "img/bul_component_solution.b4bcf3e3.svg";